<template>
    <b-row class="p-0 p-0">
        <!-- begining of the service -->
        <b-col lg="12" class="p-0 m-0 mt-5 px-5">
            <b-row class="p-0 m-0 px-5">
                <b-col lg="12" class="pb-5">
                    <h5 class="clist-title text-center">Лицензии и документы</h5>
                    <!-- <h6 class="service-desc text-center">Мы предлагаем вам лучший сервис криптотрейдинга в Казахстане.</h6> -->
                </b-col>
                <b-col lg="12" class="text-center">
                  <iframe src="https://drive.google.com/file/d/1T_BDmtEx4DZSwA6F35MWowbjulBdg26K/preview" width="900" height="780" allow="autoplay"></iframe>
                </b-col>
               
            </b-row>
        </b-col>
        <!-- end of the service -->
    </b-row>
</template>

<script>
    
    import axios from 'axios';
    import {mapActions,mapState} from 'vuex';
    export default {
        name: "PdfViewer",
        data(){
            return {
                svgWidth: 150,
                svgHeight: 30,
                coinData: [],
                pdfUrl: '@/assets/doc_lic.pdf', 
            }
        },
        methods:{
            changeRoute(routeName){
                this.$router.push('/'+routeName)
            },
            async fetchBitcoinPriceData(ids) {
                const endpoint = 'https://api.coingecko.com/api/v3/coins/markets?x_cg_demo_api_key=CG-UhwnpGqWNHeMipRrQ8Wr5Yxr';
                const params = {
                    vs_currency: 'usd',
                    days: 0, // Fetch 7 days of data
                    interval: 'daily',
                    ids:ids,
                    order: 'market_cap_desc', // Order by market capitalization
                    per_page: 2, // Number of coins per page
                    page: 1, // Page number
                    sparkline: true // Disable sparkline
                };

                try {
                    const response = await axios.get(endpoint, {
                        params: params,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CoinGecko-Api-Key': 'CG-UhwnpGqWNHeMipRrQ8Wr5Yxr'
                        }
                    });
                    
                    console.log('Bitcoin price data:', response.data);
                    
                
                    // Truncate sparkline_in_7d to include only the last 7 days
                    const coinData = response.data.map(coin => {
                        const sparklineData = coin.sparkline_in_7d.price.slice(-7); // Get the last 7 days
                        return { ...coin, sparkline_in_7d: sparklineData };
                    });

                    
                    this.coinData = this.coinData.concat(coinData);
                    
                } catch (error) {
                    console.error('Error fetching Bitcoin price data:', error);
                }
            },
            generatePath(priceData, index) {
                const dataLength = priceData.length;
                const priceMax = Math.max(...priceData);
                const priceMin = Math.min(...priceData);
                const priceRange = priceMax - priceMin;
                const xStep = this.svgWidth / (dataLength - 1);

                let path = `M0 ${this.svgHeight - ((priceData[0] - priceMin) / priceRange) * this.svgHeight}`;
                for (let i = 1; i < dataLength; i++) {
                    const x = i * xStep;
                    const y = this.svgHeight - ((priceData[i] - priceMin) / priceRange) * this.svgHeight;
                    path += ` L${x} ${y}`;
                }

                return path;
            },
            toggleAccordion(index) {
                this.items[index].active = !this.items[index].active;
            },
            hasRole(roleName){
                if(this.loginedUser && this.loginedUser.userRoles){
                    let roleNames = this.loginedUser.userRoles;
                    if(roleNames.length>0){
                    //alert(JSON.stringify(roleNames));
                    for(let r=0;r<roleNames.length;r++){
                        
                        if(roleNames[r].name===roleName){
                        return true;
                        }
                    }
                    }
                    else{
                    return false;
                    }
                }
                return false;
                
                
            }
        },
        mounted(){
            this.fetchBitcoinPriceData( 'bitcoin,ethereum');
      
            this.fetchBitcoinPriceData( 'tether,binancecoin');
        },
        computed:{
            ...mapState([
                'loginedUser'
            ]),
        }
        
    }   
</script>
<style>
    .copyright{        
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .main-bottom-top{
        height: 1px;
        background: var(--Neutrals-2, #23262F);
    }
    .no-style-input{
        appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        color: inherit;
        line-height: inherit;
        padding: 0;
        margin: 0;
    }
    .sub-container{
        border-radius: 16px;
        border: 2px solid var(--Neutrals-6, #E6E8EC);
    }
    .footer-addr{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .footer-link{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .accordion-item{
        cursor: pointer;
    }
    .accordion-item-answer{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .accordion-item-question{
        cursor: pointer;
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .accordion-item {
        width: 100%;
        max-width: 546px;
        margin: 0 auto;
        border-bottom:1px solid var(--Neutrals-3, #353945);
        
    }
    .service-btn-container{
        cursor: pointer;
        border-radius: 12px;
        background: var(--Primary-1, #EFB914);
    }
    .service-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .service-item-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .service-item-name{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .service-item{
        border-radius: 20px;
        background: var(--Neutrals-1, #141416);
    }
    .service-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .no-style {
        color: inherit; /* Inherit color from parent */
        text-decoration: none; /* Remove underline */
    }
    .news-item-desc{
        
        color: var(--Neutrals-4, #777E90);
        overflow: visible; 
        white-space: normal; 
        text-overflow: clip;
        /* Caption */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
    }
    .news-item-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .main-news-desc{
        overflow: hidden;
        color: var(--Neutrals-4, #777E90);
        text-overflow: ellipsis;
        white-space: pre-wrap;
        height: auto;
        /* Body 2 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }
    .main-news-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px; /* 125% */
        letter-spacing: -0.96px;
    }
    .trade-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .trade-btn{
        cursor: pointer;
        border-radius: 8px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .list-text-percentage{
        color: var(--Primary-4, #58BD7D);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-price{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; 
    }
    .list-sep{
        height: 1px;
        border-radius: 2px;
        background: var(--Neutrals-3, #353945);
    }
    .list-text-code{
        color: var(--Neutrals-5, #B1B5C3);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-crypto{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-number{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-header-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .tab-btn:hover{
        cursor: pointer;
        border-radius: 8px;
        background: var(--Neutrals-3, #353945);
    }
    .tab-btn:hover .tab-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
    }
    .tab-btn-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-container{
        cursor: pointer;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .clist-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px;
        letter-spacing: -0.96px;
    }
    .main-sep{
        height: 1px;
        background: #B1B5C3;
    }
    .crypto-cost-current{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
    }
    .crypto-cost-prev{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .crypto-percentage{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        border-radius: 24px;
        background: var(--Primary-3, #FF6838);
    }
    .crypto-name{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
    .crypto-item:hover{
        cursor: pointer;
        border-radius: 16px;
        background: var(--Neutrals-3, #353945);
        box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.10);
    }
    .banner-crypto-container{
        border-radius: 24px;
        background: var(--Neutrals-2, #23262F);
    }
    .banner-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        letter-spacing: -1.28px;
    }
    .banner-desc{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .crypto-btn{
        border-radius: 12px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .crypto-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: right;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
</style>

